import * as yup from 'yup'

export const otpValidator = yup
    .string()
    .required('Please enter the 6-digit code')
    .matches(/^[0-9]{6}$/, 'Code must be exactly 6 digits')
    .length(6, 'Code must be exactly 6 digits')

export const mobileVerifySchema = yup
    .object({
        otp: otpValidator,
    })
    .required()

export type MobileVerifyFormValues = yup.InferType<typeof mobileVerifySchema>
